import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { UpdateDailyTransferBody, DailyTransferResponse, updateDailyTransfer, CreateDailyTransferBody, createDailyTransfer, UpdateDailyTransferQueries } from '../../services/apiSLTP/dailyReports/dailyTransfers';

type UseUpdateDailyTransferMutationOptions = MutationOptions<DailyTransferResponse, Error, { DailyTransferId: string; data: UpdateDailyTransferBody; queries?: UpdateDailyTransferQueries }>;

export const useUpdateDailyTransferMutation = (options?: UseUpdateDailyTransferMutationOptions) => {
    const DailyTransferMutation: MutationFunction<DailyTransferResponse, { DailyTransferId: string; data: UpdateDailyTransferBody; queries?: UpdateDailyTransferQueries }> = async ({ DailyTransferId, data, queries }) => {
        try {
            const response: DailyTransferResponse = await updateDailyTransfer(DailyTransferId, data, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTransfer');
        }
    };

    return useMutation(DailyTransferMutation, options);
};

type UseCreateDailyTransferMutationOptions = MutationOptions<DailyTransferResponse, Error, CreateDailyTransferBody>;

export const useCreateDailyTransferMutation = (options?: UseCreateDailyTransferMutationOptions) => {
    const DailyTransferMutation: MutationFunction<DailyTransferResponse, CreateDailyTransferBody> = async (data) => {
        try {
            const response: DailyTransferResponse = await createDailyTransfer(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTransfer');
        }
    };

    return useMutation(DailyTransferMutation, options);
};
